<script setup lang="ts">
  import { Picture } from '@travelata-libs/ui-kit';
  import { computed } from 'vue';
  import { type AppDownloadStore } from '@/shared/model';
  import { APP_BADGES, type AppBadge } from '../../config/logos';

  interface FooterAppBadgesProps {
    visibleStorages?: AppDownloadStore[];
  }

  const props = withDefaults(defineProps<FooterAppBadgesProps>(), {
    visibleStorages: () => ['appstore', 'playstore'],
  });

  interface AppBadgeEmits {
    (e: 'download', action: AppDownloadStore): void;
  }
  const emit = defineEmits<AppBadgeEmits>();

  const visibleBadges = computed<AppBadge[]>(() =>
    APP_BADGES.filter((badge) => props.visibleStorages.includes(badge.type)),
  );
</script>

<template>
  <div
    class="footer-app-badges"
    data-testid="footer-app-badges"
  >
    <div
      v-for="badge in visibleBadges"
      :key="badge.file"
      class="footer-app-badges__item"
      @click="emit('download', badge.type)"
    >
      <Picture
        :path="`app/${badge.file}`"
        :extensions="[]"
        :high-resolution="false"
        fit="contain"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
  .footer-app-badges {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    &__item {
      display: block;
      flex: 0 0 auto;
      height: 30px;
      width: 100px;
    }
  }
</style>
